<div class="agenda-projects-container">
  <p-toast></p-toast>
  <p-confirmDialog></p-confirmDialog>

  <div class="dashboard-header">
    <div class="header-title-block">
      <h1>Agenda Projects</h1>
      <p class="dashboard-subtitle">{{ totalRecords }} projet(s) agenda{{ showArchived ? ' archivé(s)' : '' }}</p>
    </div>
  </div>

  <p-card styleClass="actions-card">
    <ng-template pTemplate="content">
      <div class="actions-bar">
        <div class="filters-row">
          <div class="search-section">
            <span class="p-input-icon-left">
              <i class="pi pi-search"></i>
              <input
                pInputText
                type="text"
                [(ngModel)]="searchTerm"
                placeholder="Rechercher nom, téléphone, email ou titre..."
                (ngModelChange)="onSearchChange()" />
            </span>
          </div>

          <div class="filter-section">
            <label class="filter-label">Statut lead</label>
            <p-dropdown
              [options]="leadStatusOptions"
              [(ngModel)]="selectedLeadStatus"
              placeholder="Tous les statuts"
              optionLabel="label"
              optionValue="value"
              [showClear]="true"
              (onChange)="onSearchChange()">
            </p-dropdown>
          </div>

          <div class="filter-section" *ngIf="isAdmin">
            <label class="filter-label">Vendeur</label>
            <p-dropdown
              [options]="userOptions"
              [(ngModel)]="selectedUserId"
              placeholder="Tous les vendeurs"
              optionLabel="label"
              optionValue="value"
              [showClear]="true"
              [filter]="true"
              filterBy="label"
              appendTo="body"
              (onChange)="onSearchChange()">
            </p-dropdown>
          </div>
        </div>

        <div class="toolbar-action-buttons">
          <div class="action-execute-group">
            <p-dropdown
              [options]="actionMenuOptions"
              [(ngModel)]="selectedAction"
              optionLabel="label"
              optionValue="value"
              placeholder="Choisir une action"
              [showClear]="true"
              (onChange)="onActionMenuChange()">
            </p-dropdown>

            <p-dropdown
              *ngIf="selectedAction === 'change_status'"
              [options]="leadStatusOptions"
              [(ngModel)]="selectedBulkStatus"
              optionLabel="label"
              optionValue="value"
              placeholder="Nouveau statut"
              [showClear]="true"
              [disabled]="updatingStatus || loading">
            </p-dropdown>

            <p-dropdown
              *ngIf="selectedAction === 'assign'"
              [options]="userOptions"
              [(ngModel)]="selectedAssignUserId"
              optionLabel="label"
              optionValue="value"
              placeholder="Conseiller cible"
              [showClear]="true"
              [filter]="true"
              filterBy="label"
              appendTo="body"
              [disabled]="assigning || loading">
            </p-dropdown>

            <p-button
              label="Exécuter"
              icon="pi pi-play"
              (onClick)="executeSelectedAction()"
              [disabled]="!canExecuteSelectedAction()"
              [loading]="isExecutingSelectedAction()"
              styleClass="p-button-primary"
              pTooltip="Exécuter l'action sélectionnée">
            </p-button>
          </div>

          <div class="toolbar-utility-buttons">
            <p-button
              icon="pi pi-sun"
              [label]="todayOnly ? 'Aujourd\'hui ✓' : 'Aujourd\'hui'"
              (onClick)="toggleTodayFilter()"
              [styleClass]="todayOnly ? 'p-button-sm today-btn-active' : 'p-button-sm p-button-outlined'"
              pTooltip="Afficher uniquement les RDV d'aujourd'hui">
            </p-button>

            <p-button
              icon="pi pi-inbox"
              [label]="showArchived ? 'Archivés ✓' : 'Archivés'"
              (onClick)="toggleArchivedFilter()"
              [styleClass]="showArchived ? 'p-button-sm today-btn-active' : 'p-button-sm p-button-outlined'"
              pTooltip="Afficher les RDV archivés">
            </p-button>

            <p-button
              icon="pi pi-file-excel"
              label="Exporter Excel"
              (onClick)="exportToExcel()"
              [loading]="exportingExcel"
              [disabled]="exportingExcel || loading"
              styleClass="p-button-sm p-button-success p-button-outlined"
              [pTooltip]="'Exporter ' + getExportScopeLabel() + ' en fichier Excel (.xlsx)'">
            </p-button>

            <p-button
              icon="pi pi-times"
              (onClick)="clearFilters()"
              [disabled]="!hasActiveFilters()"
              styleClass="p-button-secondary"
              pTooltip="Effacer les filtres">
            </p-button>

            <p-button
              icon="pi pi-refresh"
              (onClick)="refresh()"
              [loading]="loading"
              pTooltip="Actualiser">
            </p-button>
          </div>
        </div>
      </div>
    </ng-template>
  </p-card>

  <!-- Barre de sélection -->
  <div class="selection-bar" *ngIf="selectedProjects.length > 0 || allTableSelected">
    <div class="selection-info">
      <i class="pi pi-check-circle"></i>
      <span>{{ getSelectedProjectsCount() }} RDV sélectionné(s)</span>
    </div>
    <div class="selection-actions">
      <p-button *ngIf="canSelectEntireTable()" label="Sélectionner tout le tableau" icon="pi pi-list-check"
        (onClick)="selectEntireTable()" styleClass="p-button-secondary p-button-sm"></p-button>
      <p-button label="Désélectionner" icon="pi pi-times" (onClick)="clearSelection()"
        styleClass="p-button-text p-button-sm"></p-button>
    </div>
  </div>

  <div class="table-container">
    <p-table
      [value]="agendaProjects"
      [loading]="loading"
      [paginator]="true"
      [lazy]="true"
      [lazyLoadOnInit]="false"
      [totalRecords]="totalRecords"
      [rows]="rows"
      [first]="first"
      [rowsPerPageOptions]="[10,50,100]"
      (onLazyLoad)="onPageChange($event)"
      [showCurrentPageReport]="true"
      currentPageReportTemplate="Affichage de {first} à {last} sur {totalRecords} projets agenda"
      responsiveLayout="scroll"
      dataKey="id">

      <ng-template pTemplate="header">
        <tr>
          <th style="width: 3rem">
            <p-checkbox [binary]="true" [ngModel]="areAllVisibleSelected()"
              [indeterminate]="areSomeVisibleSelected() && !areAllVisibleSelected()"
              [disabled]="!hasSelectableVisibleProjects()" (onChange)="toggleAllSelection($event)"
              pTooltip="Tout sélectionner">
            </p-checkbox>
          </th>
          <th>Client</th>
          <th>Email</th>
          <th>Téléphone</th>
          <th>Objet</th>
          <th>RDV</th>
          <th>Phase</th>
          <th>Statut lead</th>
          <th>Résultat d'appel</th>
          <th>Actions</th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-item>
        <tr [class.selected-row]="isProjectSelected(item)">
          <td>
            <p-checkbox [binary]="true" [ngModel]="isProjectSelected(item)" [disabled]="!canSelectProject(item)"
              (onChange)="toggleProjectSelection(item, $event)">
            </p-checkbox>
          </td>

          <td>
            <div class="client-info">
              <div class="client-avatar">{{ getClientInitials(item) }}</div>
              <div class="client-details-text">
                <div class="client-name">{{ getClientShortName(item) }}</div>
                <div class="client-meta-tags">
                  <p-tag *ngIf="getVendeurName(item) !== '-'" [value]="getVendeurName(item)" severity="info"
                    [rounded]="true" icon="pi pi-user" styleClass="meta-tag"></p-tag>
                  <p-tag *ngIf="getRdvTakerName(item)" [value]="getRdvTakerName(item)!" severity="secondary"
                    [rounded]="true" icon="pi pi-calendar-plus" styleClass="meta-tag"></p-tag>
                  <p-tag *ngIf="item.origine" [value]="getOrigineLabel(item.origine)"
                    [severity]="getOrigineColor(item.origine)" [rounded]="true" styleClass="meta-tag"></p-tag>
                </div>
              </div>
            </div>
          </td>

          <td>
            <a *ngIf="item.email; else noEmail" [href]="'mailto:' + item.email" class="contact-link">{{ item.email }}</a>
            <ng-template #noEmail><span class="text-muted">-</span></ng-template>
          </td>

          <td>
            <!-- Passe par openCall() : un lien tel: brut contournerait l'armement
                 du suivi NRP (résultat d'appel jamais écrit pour cet appel). -->
            <a *ngIf="item.telephone; else noPhone" href="javascript:void(0)"
               (click)="openCall(item)" class="contact-link">{{ item.telephone }}</a>
            <ng-template #noPhone><span class="text-muted">-</span></ng-template>
          </td>

          <td>
            <div class="comment-cell" *ngIf="editingCommentId !== item.id; else editCommentTpl">
              <span class="comment-text" *ngIf="item.description; else noComment"
                [pTooltip]="item.description">{{ item.description }}</span>
              <ng-template #noComment><span class="text-muted">-</span></ng-template>
              <button class="edit-date-btn" (click)="startEditComment(item)" pTooltip="Modifier l'objet">
                <i class="pi pi-pencil"></i>
              </button>
            </div>
            <ng-template #editCommentTpl>
              <div class="edit-comment-cell">
                <textarea
                  [(ngModel)]="editComment"
                  rows="3"
                  class="edit-comment-input"
                  placeholder="Ce qu'on a fait avec ce contact…"></textarea>
                <div class="edit-date-actions">
                  <button class="edit-date-save" (click)="saveComment(item)" [disabled]="savingCommentId === item.id" pTooltip="Enregistrer">
                    <i class="pi pi-check"></i>
                  </button>
                  <button class="edit-date-cancel" (click)="cancelEditComment()" pTooltip="Annuler">
                    <i class="pi pi-times"></i>
                  </button>
                </div>
              </div>
            </ng-template>
          </td>

          <td>
            <div class="agenda-cell" *ngIf="editingItemId !== item.id; else editDateTpl">
              <div class="agenda-date" [class.today-badge]="formatDate(item.start_at).startsWith('Aujourd')">
                {{ formatDate(item.start_at) }}
              </div>
              <button class="edit-date-btn" (click)="startEditDate(item)" pTooltip="Modifier la date/heure">
                <i class="pi pi-pencil"></i>
              </button>
            </div>
            <ng-template #editDateTpl>
              <div class="edit-date-cell">
                <input
                  type="datetime-local"
                  [(ngModel)]="editStartAt"
                  class="edit-date-input" />
                <div class="edit-date-actions">
                  <button class="edit-date-save" (click)="saveDate(item)" [disabled]="savingDateId === item.id" pTooltip="Enregistrer">
                    <i class="pi pi-check"></i>
                  </button>
                  <button class="edit-date-cancel" (click)="cancelEditDate()" pTooltip="Annuler">
                    <i class="pi pi-times"></i>
                  </button>
                </div>
              </div>
            </ng-template>
          </td>

          <td>
            <p-tag [value]="item.phase || '—'" [severity]="getPhaseSeverity(item.phase)" [rounded]="true"
              [style]="{ fontSize:'.72rem', padding:'.2rem .6rem', whiteSpace:'normal', textAlign:'left' }">
            </p-tag>
          </td>

          <td>
            <p-dropdown
              [options]="leadStatusOptionsFor(item)"
              [ngModel]="normalizeLeadStatus(item.statut_lead)"
              optionLabel="label"
              optionValue="value"
              appendTo="body"
              styleClass="lead-status-dropdown"
              [disabled]="savingLeadStatusId === item.id || !canSelectProject(item)"
              (onChange)="onLeadStatusChange(item, $event.value)">
            </p-dropdown>
          </td>

          <td>
            <div style="display:flex;flex-direction:column;gap:4px;align-items:flex-start">
              <p-tag [value]="getResultatAppelLabel(item.resultat_appel)"
                [severity]="getResultatAppelSeverity(item.resultat_appel)" [rounded]="true">
              </p-tag>
              <p-dropdown *ngIf="item.project_id"
                [options]="resultatAppelOptions"
                [ngModel]="item.resultat_appel || null"
                (onChange)="onResultatAppelChange(item, $event.value)"
                [showClear]="!!item.resultat_appel" placeholder="Changer…"
                [disabled]="savingResultatAppelId === item.id || !canSelectProject(item)"
                appendTo="body" [style]="{ minWidth:'105px', fontSize:'.8rem' }">
              </p-dropdown>
            </div>
          </td>

          <td>
            <div class="row-action-buttons">
              <p-button
                icon="pi pi-eye"
                pTooltip="Voir les détails"
                (onClick)="viewAgendaProject(item)"
                [disabled]="loading"
                styleClass="p-button-text p-button-info">
              </p-button>

              <p-button
                icon="pi pi-phone"
                pTooltip="Appeler"
                (onClick)="openCall(item)"
                [disabled]="!item.telephone"
                styleClass="p-button-text p-button-success">
              </p-button>

              <p-button
                label="SMS"
                pTooltip="Envoyer un SMS"
                (onClick)="openSms(item)"
                [loading]="sendingSmsId === item.id"
                [disabled]="!item.telephone || sendingSmsId === item.id"
                styleClass="p-button-text p-button-warning sms-text-btn">
              </p-button>

              <p-button
                icon="pi pi-comment"
                [pTooltip]="item.commentaire || 'Aucun commentaire'"
                (onClick)="openComment(item)"
                [styleClass]="item.commentaire ? 'p-button-text btn-comment has-comment' : 'p-button-text btn-comment'">
              </p-button>

              <p-button
                icon="pi pi-upload"
                pTooltip="Charger dans le comparateur"
                (onClick)="loadAgendaProject(item)"
                [loading]="convertingId === item.id"
                [disabled]="loading || deletingId === item.id"
                styleClass="p-button-text p-button-success">
              </p-button>

              <p-button
                [icon]="item.is_archived ? 'pi pi-replay' : 'pi pi-inbox'"
                [pTooltip]="item.is_archived ? 'Désarchiver' : 'Archiver'"
                (onClick)="toggleArchive(item)"
                [loading]="archivingId === item.id"
                [disabled]="loading || deletingId === item.id || !canSelectProject(item)"
                styleClass="p-button-text p-button-secondary">
              </p-button>

              <p-button
                icon="pi pi-trash"
                pTooltip="Supprimer"
                (onClick)="confirmDelete(item)"
                [loading]="deletingId === item.id"
                [disabled]="loading || convertingId === item.id"
                styleClass="p-button-text p-button-danger">
              </p-button>
            </div>
          </td>
        </tr>
      </ng-template>

      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="10">
            <div class="empty-state">
              <i class="pi pi-calendar"></i>
              <h3>Aucun projet agenda trouvé</h3>
              <p>Les cartes récupérées depuis Google Agenda apparaîtront ici.</p>
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>

<p-dialog
  [(visible)]="showDetailDialog"
  [modal]="true"
  [style]="{width: '720px'}"
  [closable]="true"
  [draggable]="false"
  [resizable]="false"
  styleClass="agenda-detail-dialog"
  (onHide)="closeDetailDialog()">
  <ng-template pTemplate="header">
    <div class="detail-dialog-header">
      <i class="pi pi-calendar"></i>
      <div>
        <h3>Détails Projet Agenda</h3>
        <p *ngIf="selectedAgendaProject">{{ getClientName(selectedAgendaProject) }}</p>
      </div>
    </div>
  </ng-template>

  <ng-template pTemplate="content">
    <div class="detail-grid" *ngIf="selectedAgendaProject">
      <div class="detail-item" *ngFor="let entry of getAgendaProjectDetailEntries(selectedAgendaProject)">
        <span class="detail-label">{{ entry.label }}</span>
        <pre class="detail-value">{{ formatValue(entry.value) }}</pre>
      </div>
    </div>
  </ng-template>

  <ng-template pTemplate="footer">
    <div class="detail-footer">
      <p-button
        label="Fermer"
        icon="pi pi-times"
        (onClick)="closeDetailDialog()"
        styleClass="p-button-text p-button-secondary">
      </p-button>

      <p-button
        label="Charger"
        icon="pi pi-upload"
        *ngIf="selectedAgendaProject"
        (onClick)="loadAgendaProject(selectedAgendaProject)"
        [loading]="convertingId === selectedAgendaProject.id"
        styleClass="p-button-success">
      </p-button>
    </div>
  </ng-template>
</p-dialog>

<!-- ─── Dialog SMS pré-rédigé ─────────────────────────── -->
<p-dialog
  header="Vérifier et envoyer le SMS"
  [(visible)]="smsDialogVisible"
  [modal]="true"
  [style]="{ width:'560px', maxWidth:'96vw' }"
  [dismissableMask]="true"
>
  <div *ngIf="smsDialogItem" class="sms-preview-dialog">

    <!-- Destinataire -->
    <div class="sms-recipient">
      <i class="pi pi-mobile"></i>
      <div>
        <div class="sms-recipient-name">{{ getClientName(smsDialogItem) }}</div>
        <div class="sms-recipient-phone">{{ smsDialogPhone }}</div>
      </div>
    </div>

    <!-- Corps SMS éditable -->
    <div class="sms-body-label">
      <i class="pi pi-pencil"></i> Message SMS
      <span class="sms-char-count" [class.sms-warn]="smsDialogContent.length > 800">
        {{ smsDialogContent.length }} caractères
      </span>
    </div>
    <textarea
      [(ngModel)]="smsDialogContent"
      rows="14"
      class="sms-textarea"
      placeholder="Rédigez votre message…">
    </textarea>

    <div class="sms-notice">
      <i class="pi pi-info-circle"></i>
      Vous pouvez modifier le message avant de l'envoyer. L'envoi est effectué via Ringover.
    </div>
  </div>

  <ng-template pTemplate="footer">
    <button pButton type="button" label="Annuler" icon="pi pi-times"
      class="p-button-text p-button-secondary"
      (click)="smsDialogVisible = false" [disabled]="smsDialogSending">
    </button>
    <button pButton type="button" label="Envoyer le SMS" icon="pi pi-send"
      class="p-button-sm"
      style="background:#0891b2;border-color:#0891b2"
      [disabled]="smsDialogSending || !smsDialogContent.trim()"
      [loading]="smsDialogSending"
      (click)="sendSmsFromDialog()">
    </button>
  </ng-template>
</p-dialog>

<!-- Dialog commentaire (Transaction.commentaire) -->
<p-dialog header="Commentaire" [(visible)]="commentDialogVisible" [modal]="true" [draggable]="false"
  [resizable]="false" [style]="{width: '520px', maxWidth: '95vw'}">
  <div style="display:flex;flex-direction:column;gap:8px">
    <div style="font-size:12px;color:#888">{{ commentDialogTitle }}</div>
    <textarea [(ngModel)]="commentDialogText" rows="8"
      style="width:100%;box-sizing:border-box;resize:vertical;border:1px solid #cfd8dc;border-radius:8px;padding:8px;font:inherit"
      [disabled]="!commentDialogProjectId"
      placeholder="Ce qu'on a fait avec ce contact…"></textarea>
    <div style="font-size:12px;color:#888">
      <i class="pi pi-info-circle"></i>
      <span *ngIf="commentDialogProjectId">Commentaire partagé avec la table transactions et l'historique.</span>
      <span *ngIf="!commentDialogProjectId">RDV sans projet CAC : chargez-le dans le comparateur pour pouvoir commenter.</span>
    </div>
  </div>
  <ng-template pTemplate="footer">
    <button pButton type="button" label="Fermer" icon="pi pi-times"
      class="p-button-text p-button-secondary" (click)="commentDialogVisible = false"
      [disabled]="savingCommentaire">
    </button>
    <button pButton type="button" label="Enregistrer" icon="pi pi-check"
      class="p-button-sm" [loading]="savingCommentaire"
      [disabled]="savingCommentaire || !commentDialogProjectId" (click)="saveCommentaire()">
    </button>
  </ng-template>
</p-dialog>
